<wm-de-label
  [entity]="entity"
  [for]="entity.templateCode"
  [displayOnly]="true"
  *ngIf="showLabel"
></wm-de-label>
<div class="sketch-container" style="border: 1px solid black; display: inline-block;">
  <div fxLayout="row">
    <img [src]="imageDataPath" style="width: 100%; aspect-ratio: 1 / 1; display: block;" *ngIf="imageDataPath" />
    <div style="width: 100%; aspect-ratio: 1 / 1;" *ngIf="!imageDataPath"></div>
  </div>
</div>
